import React from "react";
import "../styles/Service.css";
import arrow from '../assest/arrow.png';
import { Link } from 'react-router-dom';
import products from './Product';

const Services = () => {
  return (
    <div className="financial-wrapper" id="solution">
      <div className="financial-container">
        <div className="financial-header">
          <div className="financial-heading-text">
            <h2 className="label"> Our &nbsp;Solution</h2>
            <h1 className="heading2">
              We focus on what matters: understanding your business and solving real challenges with the right tools.    </h1>
          </div>
          <div className="financial-sub">
            {/* <p className="para2">
              We focus on what matters: understanding your business and solving real challenges with the right tools.
            </p> */}
            {/* <button
              className="vision-btn"
              onClick={() => {
                document.getElementById("contact").scrollIntoView({ behavior: "smooth" });
              }}
            >
              Contact us &nbsp;<i className="fas fa-arrow-right"></i>
            </button> */}
          </div>
        </div>

        <div className="card-wrapper">
          {products.map(product => (
            <Link to={`/product/${product.id}`} key={product.id} className="card-link">
              <div className="card">
                <img src={product.bannerimage} alt={product.name} />
                <div className="card-overlay">
                  <div className="icon-with-text">
                    <div className="icon-circle">
                      <p className="para-main">{product.name}</p>
                      <img src={arrow} alt="arrow" />
                    </div>
                    <br />
                    <p className="para3">{product.description}</p>
                    <br />
                    <button className="explore">
                      Learn more <i className="fas fa-arrow-right arrow"></i>
                    </button>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
        <div className="button-position">
         <button
              className="solution-btn"
              onClick={() => {
                document.getElementById("contact").scrollIntoView({ behavior: "smooth" });
              }}
            >
              Contact us &nbsp;<i className="fas fa-arrow-right"></i>
            </button>
            </div>
      </div>
    </div>
  );
};

export default Services;
